export const t = { "en": { "breezeSetupMeetingNotetakerAgent": { "setupPrompt": "Help me set up Meeting Notetaker for my portal." } } };
export const d = [];